import downArrow from './images/icons/imagesVectors/down_arrow.png';
import upArrow from './images/icons/imagesVectors/up_arrow.png';
import CaretRight from './images/svg/CaretRight.svg';

const imagesVector = {
  CaretRight,
  downArrow,
  upArrow,
};

export default imagesVector;
